import type { FaqAnswerBlock, FaqRichText } from '~/features/my-wallet/types/faq'

const EMPHASIS_MARK = '**'

export function parseEmphasis(text: string): FaqRichText {
  return text
    .split(EMPHASIS_MARK)
    .map((segmentText, index) => ({ text: segmentText, isBold: index % 2 === 1 }))
    .filter(segment => segment.text.length > 0)
}

export function richTextToPlain(richText: FaqRichText) {
  return richText.map(segment => segment.text).join('')
}

// The mapped type forces every new block kind to define its plain-text form.
const BLOCK_PLAIN_TEXT: { [TKind in FaqAnswerBlock['kind']]: (block: Extract<FaqAnswerBlock, { kind: TKind }>) => string } = {
  paragraph: block => richTextToPlain(block.text),
  bullets: block => block.items.map(richTextToPlain).join(' '),
  numbered: block => block.items.map(richTextToPlain).join(' '),
}

export function answerToPlainText(answer: FaqAnswerBlock[]) {
  return answer
    .map(block => (BLOCK_PLAIN_TEXT[block.kind] as (answerBlock: FaqAnswerBlock) => string)(block))
    .join(' ')
}
